module.exports = __webpack_public_path__ + "static/media/29EUNOG13.6be44a99.jpg";